import moment from 'moment'

export default (current, next) => {
    return moment(current).diff(next, 'minutes');
}
